
import {
  Vue,
  Component,
  Prop,
  PropSync,
  Watch,
  Inject,
} from "vue-property-decorator";
import Marquee from "@/components/semantics/Marquee.vue";
import SortHeader from "@/components/base/table/header/SortHeader.vue";
import { Action, Getter } from "vuex-class";
import Table from "@/components/base/table/body/TableBoxText.vue";
import Pagination from "@components/base/pagination/PcmPagination.vue";
import { deepClone, getParentArea } from "@/common/utils";
@Component({
  name: "Apply",
  components: {
    Marquee,
    SortHeader,
    Table,
    Pagination,
  },
})
export default class Apply extends Vue {
  @Action("policy/getApplyList") private getApplyList: any;
  @Getter("cityName") private cityName: any;
  @Getter("cityId") private cityId: any;
  @Getter("city") private city: any;
  @Getter("provinceId") private provinceId: any;
  areaOption = this.$root.$data.areaOption;
  loading = false;
  tableData: any = [];
  searchValue: any = "";
  total2 = 0;
  pages2 = 0;
  current2 = 1;
  size2 = 12;
  current_option: any = {};
  created() {
    this.getData(0);
  }
  currentChange2(params: any) {
    this.current2 = params;
    this.getData(1);
  }
  async getData(type: any) {
    // 0-default|1-search
    this.loading = true;
    let options: any = {
      pageNumber: this.current2,
      pageSize: this.size2,
      order: "desc",
      sort: "releaseDate",
      locationAddressCode: this.city.locationAddressCode,
    };
    if (type === 1) {
      options = {
        ...options,
        ...this.current_option,
      };
    } else {
      if (!this.city.locationAddressCode) {
        options.addressCode = this.city.id;
      }
      options = {
        ...options,
      };
    }
    this.getApplyList(options)
      .then(({ code, result, msg }: any) => {
        if (code === 200) {
          this.loading = false;
          const { total, records, pages } = result;
          this.tableData = records.map(
            ({ nature, state, supportAmount, gmtCreate, ...item }: any) => {
              const money = `${
                supportAmount ? (supportAmount / 10000).toFixed(0) : "--"
              }万元`;
              let stateWord = ["", "未开始", "申报期内", "暂停申报"];
              state = stateWord[state];
              let declareYear = gmtCreate
              item.title = item.title + "-" + item.dispatchDirection;
              return {
                tags: [money, nature, state, declareYear],
                ...item,
              };
            }
          );
          this.total2 = total;
          this.pages2 = pages;
        }
      })
      .catch((err: any) => err)
      .finally(() => (this.loading = false));
  }
  clickMarquee(options: any) {
    options.addressCode ? options.addressCode : this.cityId;
    this.current_option = options;
    this.getData(1);
  }
  search(options: any) {
    this.current_option = {
      ...this.current_option,
      ...options,
    };
    this.getData(1);
  }
  toDetail({ id, declareItemId }: any) {
    /*const { href } = this.$router.resolve({
      path: "/detail/apply",
      query: {
        projectId: declareItemId,
        directionId: id,
      },
    });

    window.open(href, "_blank");*/
    this.$router.push({
      path: "/detail/apply",
      query: {
        projectId: declareItemId,
        directionId: id,
      },
    });
  }
}
